import { Link } from "react-router-dom";

export default function PaymentCancel() {
  return (
    <section className="min-h-screen flex items-center justify-center px-6" data-testid="payment-cancel">
      <div className="max-w-lg text-center">
        <p className="text-[11px] tracking-[0.3em] text-[#A4801C] mb-6">PAYMENT CANCELLED</p>
        <h1 className="font-display text-5xl md:text-6xl font-light leading-none mb-6">No worries.</h1>
        <p className="text-[#0A0A14]/70 mb-10">Your card was not charged. When you're ready, we'll be here.</p>
        <Link to="/" className="btn-editorial" data-testid="back-home">Return home <span className="arrow">→</span></Link>
      </div>
    </section>
  );
}
